"use strict";

define(['jquery', 'matchMedia', 'mage/accordion', 'domReady!'], function ($, mediaCheck) {
  'use strict';

  $.widget('mage.footer', {
    options: {
      breakpoint: '(min-width: 1024px)',
      accordionOptions: {
        active: false,
        collapsible: true,
        openedState: 'active',
        multipleCollapsible: false,
        animate: 100
      }
    },
    _create: function () {
      let self = this;
      let $container = $(self.element);
      mediaCheck({
        media: self.options.breakpoint,
        entry: function () {
          if ($container.hasClass('mage-accordion-disabled')) {
            $container.accordion('destroy').find('.list__item-content').attr('aria-hidden', 'false').show();
          }
        },
        exit: function () {
          if (!$container.hasClass('mage-accordion-disabled')) {
            $container.accordion(self.options.accordionOptions, 'deactivate');
          } else {
            $container.accordion('destroy', self.options.accordionOptions, 'deactivate');
          }
        }
      });
    }
  });
  return $.mage.footer;
});
//# sourceMappingURL=brewes-footer.babel.js.map
